import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, Badge, Select } from "@/components/ui-kit";
import { fmtDate } from "@/lib/constants";
import { ScrollText, ShieldCheck } from "lucide-react";

const ENTITIES = ["", "job", "project", "task", "inventory", "purchase_order", "user", "location"];
const ACTION_CLS = {
  create: "bg-emerald-500/15 text-emerald-500 border-emerald-500/30",
  update: "bg-blue-500/15 text-blue-500 border-blue-500/30",
  delete: "bg-red-500/15 text-red-500 border-red-500/30",
  status: "bg-indigo-500/15 text-indigo-500 border-indigo-500/30",
  inward: "bg-cyan-500/15 text-cyan-500 border-cyan-500/30",
  dispatch: "bg-green-700/15 text-green-600 dark:text-green-400 border-green-700/30",
  qa_pass: "bg-purple-500/15 text-purple-500 border-purple-500/30",
  stock_adjust: "bg-amber-500/15 text-amber-500 border-amber-500/30",
  diagnostic: "bg-slate-500/15 text-slate-500 border-slate-500/30",
  part_request: "bg-orange-500/15 text-orange-500 border-orange-500/30",
};

export default function Audit() {
  const [logs, setLogs] = useState([]);
  const [entity, setEntity] = useState("");
  useEffect(() => {
    const p = entity ? { entity } : {};
    api.get("/audit", { params: p }).then((r) => setLogs(r.data)).catch(() => {});
  }, [entity]);

  return (
    <div className="space-y-4" data-testid="audit-page">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <h1 className="font-heading text-2xl font-bold uppercase tracking-tight sm:text-3xl flex items-center gap-2"><ScrollText size={24} /> Immutable Audit Trail</h1>
          <p className="flex items-center gap-1 text-sm text-muted-foreground"><ShieldCheck size={14} className="text-emerald-500" /> Append-only compliance log · {logs.length} entries</p>
        </div>
        <Select value={entity} onChange={(e) => setEntity(e.target.value)} className="w-44" data-testid="audit-entity-filter">
          {ENTITIES.map((e) => <option key={e} value={e}>{e || "All Entities"}</option>)}
        </Select>
      </div>
      <Card className="overflow-x-auto">
        <table className="w-full min-w-[760px] text-sm">
          <thead><tr className="border-b border-border text-left font-mono text-[10px] uppercase tracking-wider text-muted-foreground">
            <th className="px-3 py-2">Timestamp</th><th className="px-3 py-2">User</th><th className="px-3 py-2">Action</th><th className="px-3 py-2">Entity</th><th className="px-3 py-2">Detail</th>
          </tr></thead>
          <tbody>
            {logs.map((l) => (
              <tr key={l.id} className="border-b border-border/60 hover:bg-accent/40" data-testid={`audit-row-${l.id}`}>
                <td className="whitespace-nowrap px-3 py-2 font-mono text-[11px] text-muted-foreground">{fmtDate(l.created_at)}</td>
                <td className="px-3 py-2"><div className="font-medium">{l.user_name || "System"}</div><div className="font-mono text-[10px] uppercase text-muted-foreground">{l.user_role || "—"}</div></td>
                <td className="px-3 py-2"><Badge className={ACTION_CLS[l.action] || "border-border"}>{l.action}</Badge></td>
                <td className="px-3 py-2 font-mono text-xs">{l.entity}</td>
                <td className="px-3 py-2 text-muted-foreground">{l.detail}</td>
              </tr>
            ))}
            {logs.length === 0 && <tr><td colSpan={5} className="px-3 py-10 text-center text-muted-foreground">No audit entries.</td></tr>}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
